export default {
      id: "import-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#import",
      toString: function () {
        return this.url;
      }
    }